import { render, staticRenderFns } from "./WirelessSpeech.vue?vue&type=template&id=c98aca1c&"
import script from "./WirelessSpeech.vue?vue&type=script&lang=js&"
export * from "./WirelessSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports